<template>
  <div>
    <base-material-card
      class="px-5 py-3"
      style="cursor: pointer"
      color="primary"
      :title="item.camera.camera_name"
      @click.native="enterInferenceSetting(item)"
    >
      <template v-slot:heading>
        <v-row class="display-1 font-weight-light">
          {{ item.camera.camera_name }}
        </v-row>

        <v-row>
          {{ item.camera_alias }}
        </v-row>
      </template>

      <v-row>
        <v-col>
          <GuardianSnapshot
            :image="snapshot.data"
            :fences="item.fences"
          ></GuardianSnapshot>
        </v-col>
      </v-row>
    </base-material-card>
  </div>
</template>

<script>
import GuardianSnapshot from "@/components/guardian/GuardianSnapshot";
import { getSnapshot } from "@/endpoint/camera";

export default {
  name: "InferenceItem",
  components: {
    GuardianSnapshot,
  },
  props: ["item"],
  data() {
    return {
      snapshot: {
        data: "",
      },
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    async init(scope) {
      scope.snapshot = await getSnapshot(this.item.camera.camera_id);
    },
    enterInferenceSetting(item) {
      this.$router.push({
        name: "inferenceSetting",
        params: { uuid: item._id },
      });
    },
  },
};
</script>